import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import arrowTopKYC from '../UserTagsPanel/arrowTopKYC.svg';

import { staticStyles } from './style';

class UserContractsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { openBlock: false };
  }

  toggleBlock = () => {
    this.setState(state => ({ openBlock: !state.openBlock }));
  };

  render() {
    const { contracts } = this.props;
    const { openBlock } = this.state;

    return (
      <div className="UserContractsPanel">
        {/* eslint-disable */}
        <div
          className={classNames('UserContractsPanel__open-close', {
            'UserContractsPanel__open-close--close': !openBlock,
          })}
          onClick={this.toggleBlock}
        />
        {/* eslint-enable */}
        <div
          className={classNames('UserContractsPanel__head', {
            'UserContractsPanel__head--hide': !openBlock,
          })}>
          <h2>Contract</h2>
        </div>
        {/* eslint-disable */}
        <img
          className={classNames('UserContractsPanel__arrowTopKYC', {
            'UserContractsPanel__arrowTopKYC--hide': !openBlock,
          })}
          src={arrowTopKYC}
          alt="arrowTopKYC"
          onClick={this.toggleBlock}
        />
        {/* eslint-enable */}
        <div
          className={classNames('UserContractsPanel__content', {
            'UserContractsPanel__content--hide': !openBlock,
          })}>
          {contracts.length ? (
            contracts.map(contract => (
              <div className="UserContractsPanel__contract" key={contract.id}>
                <a href={contract.url} download={contract.filename}>
                  {contract.title}
                </a>
              </div>
            ))
          ) : (
            <p className="UserContractsPanel__empty">No signed contracts</p>
          )}
        </div>

        <style jsx>{staticStyles}</style>
      </div>
    );
  }
}

UserContractsPanel.propTypes = {
  contracts: PropTypes.array,
};

UserContractsPanel.defaultProps = {
  contracts: [],
};

export default UserContractsPanel;
export { UserContractsPanel };
